/**
 * Utility functions for Firebase Functions integration
 */

/**
 * Get the Firebase Functions URL dynamically
 * Uses production URL in production, localhost in development
 */
export const getFunctionsUrl = async (): Promise<string> => {
  // In production, always use production URL
  if (window.location.hostname !== 'localhost') {
    return 'https://us-central1-carly-faye-foundation.cloudfunctions.net';
  }
  
  // In development, use localhost
  return 'http://localhost:5001/carly-faye-foundation/us-central1';
};

/**
 * Make a request to Firebase Functions with automatic URL resolution
 */
export const callFunction = async (functionName: string, options: RequestInit = {}): Promise<Response> => {
  const functionsUrl = await getFunctionsUrl();
  const url = `${functionsUrl}/${functionName}`;
  
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
}; 